// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toolbar {
    background-color: #eee;
    padding: 5px;
}
.toolbar button {
    padding: 2px;
    margin: 0 2px;
}
.toolbar button img {
    display: block;
}
.toolbar button:disabled {
    opacity: 0.5;
}
`, "",{"version":3,"sources":["webpack://./src/ui/panels/toolbar.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,YAAY;AAChB;AACA;IACI,YAAY;IACZ,aAAa;AACjB;AACA;IACI,cAAc;AAClB;AACA;IACI,YAAY;AAChB","sourcesContent":[".toolbar {\n    background-color: #eee;\n    padding: 5px;\n}\n.toolbar button {\n    padding: 2px;\n    margin: 0 2px;\n}\n.toolbar button img {\n    display: block;\n}\n.toolbar button:disabled {\n    opacity: 0.5;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
